'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dCredentials$002dView$0024$0024anon$002461 from "./presto.-Credentials-View$$anon$61.js";
import * as $j_presto$002e$002dCredentials$002dView$0024$0024anon$002462 from "./presto.-Credentials-View$$anon$62.js";
import * as $j_presto$002e$002dCredentials$002dView$0024$0024anon$002463 from "./presto.-Credentials-View$$anon$63.js";
import * as $j_presto$002e$002dCredentials$002dView$0024$0024anon$002464 from "./presto.-Credentials-View$$anon$64.js";
import * as $j_presto$002e$002dCredentials$002dView$0024$0024anon$002465 from "./presto.-Credentials-View$$anon$65.js";
var $p;
/** @constructor */
function $c_Lpresto_CredentialsView$$anon$60(outer) {
  this.aGX = null;
  this.aGV = null;
  this.aGW = false;
  this.aGT = null;
  this.aGU = false;
  this.aGY = false;
  this.aGZ = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.aGX = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_CredentialsView$$anon$60 as $c_Lpresto_CredentialsView$$anon$60 };
$p = $c_Lpresto_CredentialsView$$anon$60.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_CredentialsView$$anon$60;
/** @constructor */
function $h_Lpresto_CredentialsView$$anon$60() {
}
export { $h_Lpresto_CredentialsView$$anon$60 as $h_Lpresto_CredentialsView$$anon$60 };
$h_Lpresto_CredentialsView$$anon$60.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.aGX;
});
$p.t = (function() {
  if ((!this.aGW)) {
    this.aGV = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("BySeed", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("ByTfa", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("BySiteAndGroup", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("ByDocument", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
    this.aGW = true;
  }
  return this.aGV;
});
$p.ae = (function() {
  if ((!this.aGU)) {
    this.aGT = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dCredentials$002dView$0024$0024anon$002461.$c_Lpresto_CredentialsView$$anon$61(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dCredentials$002dView$0024$0024anon$002462.$c_Lpresto_CredentialsView$$anon$62(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dCredentials$002dView$0024$0024anon$002463.$c_Lpresto_CredentialsView$$anon$63(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dCredentials$002dView$0024$0024anon$002464.$c_Lpresto_CredentialsView$$anon$64(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
    this.aGU = true;
  }
  return this.aGT;
});
$p.w = (function() {
  if ((!this.aGZ)) {
    this.aGY = true;
    this.aGZ = true;
  }
  return this.aGY;
});
$p.acB = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeSum__I__O__Lio_circe_JsonObject(this, new $j_presto$002e$002dCredentials$002dView$0024$0024anon$002465.$c_Lpresto_CredentialsView$$anon$65().aeF(a), a);
});
$p.ac = (function(a) {
  return this.acB(a);
});
var $d_Lpresto_CredentialsView$$anon$60 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_CredentialsView$$anon$60, "presto.CredentialsView$$anon$60", ({
  G3: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_CredentialsView$$anon$60 as $d_Lpresto_CredentialsView$$anon$60 };
//# sourceMappingURL=presto.-Credentials-View$$anon$60.js.map
